import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Route, Router } from '@angular/router';

@Component({
  selector: 'app-cm-news-letter',
  templateUrl: './cm-news-letter.component.html',
  styleUrls: ['./cm-news-letter.component.scss']
})
export class CmNewsLetterComponent {

  newsLetterDataChildren: Route[] = [];

  constructor(private router: Router) { }

  ngOnInit(): void {
    // Find the master-data route first
    const masterDataRoute = this.router.config.find(r => r.path === 'common');

    // Then find the 'other' child route within master-data
    const otherRoute = masterDataRoute?.children?.find(child => child.path === 'news-letter');

    // Get the third-level children (auction-hall, documents, etc.)
    this.newsLetterDataChildren = otherRoute?.children ?? [];
  }
}
